import { LinkProps } from 'react-router-dom';

import { TableRow, TableRowProps, makeStyles } from '@material-ui/core';

import classNames from 'classnames';

import { useNavigate } from '../../behaviors';

const useStyles = makeStyles(() => ({
  row: {
    cursor: 'pointer',
  },
}));

export type LinkableTableRowProps = TableRowProps & { to: LinkProps['to'] };

export const LinkableTableRow = ({
  children,
  to,
  hover = true,
  ...tableRowProps
}: LinkableTableRowProps) => {
  const navigate = useNavigate();
  const classes = useStyles();

  const handleClick = (event: React.MouseEvent<HTMLTableRowElement>) => {
    if (!to) return;

    // Check if cmd (Mac) or ctrl (Windows/Linux) key is pressed
    if (event.metaKey || event.ctrlKey) {
      // Open in new tab
      const url = typeof to === 'string' ? to : to.pathname || '';
      window.open(url, '_blank');
      return;
    }

    const target = event.target as Element | null;
    const clickedInAnchor = Boolean(target && target.closest('a'));
    // Always skip navigation if user clicked inside a link - the link will handle navigation
    if (clickedInAnchor) return;

    navigate(to);
  };

  return (
    <TableRow
      hover={hover}
      className={classNames(classes.row, tableRowProps.className)}
      onClick={handleClick}
      {...tableRowProps}
    >
      {children}
    </TableRow>
  );
};
